import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FInfoCard from "../../components/FInfoCard/FInfoCard";
import { getcontactInfo, deleteContactInfoById } from "../../api/contactInfo";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import PhoneInput from "react-phone-input-2";
import { useFormik } from "formik";
import FInputt from "../../components/FInputt/FInputt";
import { useContactInfo } from "../../hooks/useContactInfo";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import FContainer from "../../components/FContainer/FContainer";
import { Trash } from "react-ionicons";
import VectorIcons from "../../components/VectorIcons/VectorIcons";
import Switch from "react-switch";


const EmailScreen = ({ param }) => {
  const MySwal = withReactContent(Swal);

  const route = useNavigate();
  const { getEmails, emails, deleteContactInfo, editContactInfo, loadEmails, isRefreshing } =
    useContactInfo();

  useEffect(() => {
    getEmails();
  }, []);

  return (
    <>
      <FBannerTitleButton
        title="Asocia un correo a tu cuenta"
        imageUrl={require("../../components/assets/images/mail.png")}
        titleButton={
          <Fbutton
            value="Agregar correo"
            onClick={() => {
              route("/CreateEmailScreen");
            }}
          />
        }
      />
      <FContainer>
        {emails.length > 0
          ? emails
            .sort((a, b) => {
              return b.isPrincipal - a.isPrincipal;
            })
            .map((item) => (
              <>
                <>
                  <FInfoCard
                    title="Correo Electrónico"
                    typeOfContactId={item.typeOfContactId}
                    contact={item.contact}
                    item={item}
                    onEditInfoCard={() => {
                      MySwal.fire({
                        showCloseButton: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                        html: (
                          <MySwalEditEmail
                            getEmails={getEmails}
                            editContactInfo={editContactInfo}
                            email={item}
                          />
                        ),
                      });
                    }}
                    onDeleteClick={(value) =>
                      deleteContactInfo(value.typeOfContactId, value.id)
                    }
                  />
                </>
              </>
            ))
          : null}
      </FContainer>
    </>
  );
};

const MySwalEditEmail = ({ email, getEmails, editContactInfo }) => {
  const MySwal = withReactContent(Swal);
  const [principal, setPrincipal] = useState(email.isPrincipal);

  const nextScreen = async () => {
    if ((await editContactInfo(email.id, { isPrincipal: principal })) === true) {
      Swal.fire({
        showCloseButton: true,
        icon: 'success',
        title: "Actualización exitosa",
        showConfirmButton: false,
        timer: 1500
      })
      getEmails()
      MySwal.close();
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "No se pudo crear tu dirección",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };

  return (
    <>
      <div className="border-0 w-full font-bold pt-10 pb-5">
        <Switch
          onColor="#F10C8F"
          onChange={() => {
            if (!email.isPrincipal) {
              setPrincipal(!principal);
            }
          }}
          checked={principal}
        />
        {" Marcar como dirección principal"}
      </div>
      <Fbutton value="Continuar" onClick={nextScreen} />
    </>
  );
};


export default EmailScreen;
